/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["de"] = {
    wikiLinkLabel:  "Diskutieren"
};



//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/de/timeline.js
// module id = 578
// module chunks = 3